import { Overrides } from "@material-ui/core/styles/overrides"
import { baseTheme } from "../base"

export const MuiToggleButton: Overrides["MuiToggleButton"] = {
  root: {
    height: "auto",
    padding: "1rem 1.6rem",
    borderWidth: 2,
    borderRadius: 4,
    letterSpacing: 0,
    lineHeight: "1.6rem",
    fontWeight: 500,
    textTransform: "initial",
    "&$selected": {
      color: baseTheme.palette.common.white,
    },
    transition:
      "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1), border-color 250ms cubic-bezier(0.4, 0, 0.2, 1), color 250ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  sizeSmall: {
    height: "auto",
    fontSize: "1.2rem",
    fontWeight: 700,
    padding: "0.4rem 0.8rem",
  },
}

export const MuiToggleButtonGroup: Overrides["MuiToggleButtonGroup"] = {
  grouped: {
    "&:not(:first-child)": {
      borderLeft: "none",
      marginLeft: 0,
    },
  },
}
